export default __webpack_public_path__ + "static/media/rightDarkArrow.9871dbdc.svg";